"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8958,1769,2854],{

/***/ 34553:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


var $ = __webpack_require__(82109);
var $findIndex = (__webpack_require__(42092).findIndex);
var addToUnscopables = __webpack_require__(51223);
var arrayMethodUsesToLength = __webpack_require__(29207);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ 61769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





function ObLink(_ref) {
  var children = _ref.children,
      Tag = _ref.tag,
      href = _ref.href,
      id = _ref.id,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      styles = _ref.styles,
      role = _ref.role,
      onClick = _ref.onClick,
      dataActionDetail = _ref.dataActionDetail,
      disabled = _ref.disabled,
      isExternalLink = _ref.isExternalLink,
      isRelNofollow = _ref.isRelNofollow;

  if (!children) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: href && Tag == 'a' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: href,
      target: isExternalLink ? '_blank' : null,
      rel: isRelNofollow ? 'nofollow' : null,
      className: "ob-link ".concat(className ? className : ''),
      "aria-label": ariaLabel,
      id: id,
      style: styles,
      role: role,
      onClick: onClick,
      "data-action-detail": dataActionDetail,
      "aria-disabled": disabled,
      children: children
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Tag, {
      className: "ob-link ".concat(className ? className : ''),
      "aria-label": ariaLabel,
      id: id,
      style: styles,
      role: role,
      onClick: onClick,
      "data-action-detail": dataActionDetail,
      children: children
    })
  });
}

ObLink.defaultProps = {
  tag: 'a',
  styles: {}
};
/* harmony default export */ __webpack_exports__["default"] = (ObLink);

/***/ })

}]);